function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6068_8578)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.00086 3.5008C5.31353 3.45547 2.53419 5.33347 0.786861 7.2568C0.603451 7.46042 0.501953 7.72476 0.501953 7.9988C0.501953 8.27285 0.603451 8.53718 0.786861 8.7408C2.49619 10.6235 5.26753 12.5448 8.00086 12.4988C10.7342 12.5448 13.5062 10.6235 15.2169 8.7408C15.4003 8.53718 15.5018 8.27285 15.5018 7.9988C15.5018 7.72476 15.4003 7.46042 15.2169 7.2568C13.4675 5.33347 10.6882 3.45547 8.00086 3.5008Z",
  stroke: "#1B75BB",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 8.00018C10.4999 8.4946 10.3531 8.97789 10.0784 9.38892C9.80357 9.79996 9.41307 10.1203 8.95625 10.3094C8.49942 10.4985 7.99678 10.5479 7.51187 10.4514C7.02696 10.3549 6.58156 10.1167 6.232 9.76704C5.88243 9.41739 5.6444 8.97193 5.54799 8.48699C5.45158 8.00206 5.50113 7.49943 5.69037 7.04265C5.8796 6.58587 6.20004 6.19547 6.61114 5.92079C7.02225 5.64612 7.50558 5.49951 8 5.49951C8.32839 5.49942 8.65357 5.56405 8.95697 5.6897C9.26036 5.81535 9.53603 5.99955 9.7682 6.23179C10.0004 6.46402 10.1845 6.73973 10.3101 7.04316C10.4356 7.34659 10.5002 7.67179 10.5 8.00018Z",
  stroke: "#1B75BB",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6068_8578"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgPasswordEyeBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeBlue);
export default __webpack_public_path__ + "static/media/password-eye-blue.1bfca203.svg";
export { ForwardRef as ReactComponent };